import { ICardItemResponse } from "../../services/card-list/card-list.interface";
import { actionTypes } from "./payment.actions";

export interface IPaymentState {
  cardSelected: ICardItemResponse | null;
  isCardAdded: boolean;
  isCardUpdateInitiated: boolean;
}

const initialState: IPaymentState = {
  cardSelected: null,
  isCardAdded: false,
  isCardUpdateInitiated: false,
};

export const paymentReducer = (
  state: IPaymentState = initialState,
  action: { type: string, payload: any },
) => {
  switch (action.type) {
  case actionTypes.SET_CARD_SELECTED:
    return {
      ...state,
      cardSelected: action.payload,
    };
  case actionTypes.SET_CARD_UPDATE_INITIATED:
    return {
      ...state,
      isCardUpdateInitiated: action.payload,
    };
  case actionTypes.SET_CARD_ADDED_STATUS:
    return {
      ...state,
      isCardAdded: action.payload,
      cardAddedStatus: action.payload,
    };
  default:
    return state;
  }
};
